module.exports = __webpack_public_path__ + "img/team_cur.0fe7dc3d.png";